'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _underscore = require('../utils/underscore');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _reactUtils = require('react-utils');

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _colors = require('HubStyleTokens/colors');

var _AvatarResolver = require('./AvatarResolver');

var _defaultAvatarFetcher = require('./defaultAvatarFetcher');

var _defaultAvatarFetcher2 = _interopRequireDefault(_defaultAvatarFetcher);

var _Image = require('../core/Image');

var _UIImage = require('../image/UIImage');

var _UIImage2 = _interopRequireDefault(_UIImage);

var _UIIconCircle = require('../icon/UIIconCircle');

var _UIIconCircle2 = _interopRequireDefault(_UIIconCircle);

var _iconName = require('../utils/propTypes/iconName');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var resolver = (0, _AvatarResolver.getAvatarResolver)();

// objectTypes
var COMPANY = 'COMPANY';
var CONTACT = 'CONTACT';

// Build number in DEFAULT_BASE is arbitrary, but there for a reason. See:
// HubSpot/SalesUIComponents#79.
var DEFAULT_BASE = 'https://static.hsappstatic.net/salesImages/static-1.291/avatars';
var DEFAULT_COMPANY = DEFAULT_BASE + '/default-company-avatar.png';
var DEFAULT_CONTACT = DEFAULT_BASE + '/default-avatar.png';

var SIZE_CLASSES = {
  'responsive': '',
  'extra-small': 'private-avatar--xs',
  'small': 'uiAvatarSmall private-avatar--sm',
  'medium': 'uiAvatarMedium private-avatar--md',
  'large': 'uiAvatarLarge private-avatar--lg',
  'extra-large': 'uiAvatarXLarge private-avatar--xl'
};

var BADGE_ICON_SIZES = {
  'small': 7,
  'medium': 12,
  'large': 14,
  'extra-large': 18
};

var IMAGE_SHAPES = ['default', 'circle', 'square', 'rounded', 'thumbnail'];

function getDefaultPortalId() {
  /* eslint-disable hubspot-is-special */
  if (!window.hubspot) {
    return undefined;
  }
  var _window = window,
      hubspot = _window.hubspot;

  if (hubspot.PortalIdParser && typeof hubspot.PortalIdParser.get === 'function') {
    return hubspot.PortalIdParser.get();
  }
  return hubspot.portal && hubspot.portal.id;
  /* eslint-enable hubspot-is-special */
}

exports.default = _react2.default.createClass({
  displayName: 'UIAvatar',

  mixins: [_reactAddonsPureRenderMixin2.default],

  propTypes: {
    className: _react.PropTypes.string,
    defaultImage: _react.PropTypes.string,
    domain: _react.PropTypes.string,
    email: _react.PropTypes.string,
    fetchAvatars: _react.PropTypes.func.isRequired,
    iconBackgroundColor: _react.PropTypes.string,
    iconColor: _react.PropTypes.string,
    iconName: (0, _iconName.getIconNamePropType)(),
    imageShape: _react.PropTypes.oneOf(IMAGE_SHAPES).isRequired,
    objectType: _react.PropTypes.oneOf([COMPANY, CONTACT]).isRequired,
    onClick: _react.PropTypes.func,
    portalId: _react.PropTypes.number.isRequired,
    size: _react.PropTypes.oneOf(Object.keys(SIZE_CLASSES)).isRequired,
    source: _react.PropTypes.string.isRequired,
    src: _react.PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      fetchAvatars: _defaultAvatarFetcher2.default,
      portalId: getDefaultPortalId(),
      size: 'responsive',
      imageShape: 'circle',
      objectType: CONTACT,
      iconColor: _colors.OLAF,
      iconBackgroundColor: _colors.CALYPSO
    };
  },
  getInitialState: function getInitialState() {
    return {
      avatarURI: undefined,
      error: undefined,
      loaded: false
    };
  },
  componentWillMount: function componentWillMount() {
    if (this.props.src) {
      return;
    }
    this.updateAvatarUrl(this.props);
  },
  componentDidMount: function componentDidMount() {
    if (this.props.src) {
      return;
    }
    this.startWatching();
    this.updateAvatarUrl(this.props);
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (nextProps.src && this.props.src) {
      return;
    }
    if (!nextProps.src && this.props.src) {
      this.stopWatching();
      return;
    }
    if (nextProps.src && !this.props.src) {
      this.startWatching();
    }
    this.updateAvatarUrl(nextProps);
  },
  componentWillUnmount: function componentWillUnmount() {
    this.stopWatching();
  },
  handleResolverUpdate: function handleResolverUpdate() {
    this.updateAvatarUrl(this.props);
  },
  startWatching: function startWatching() {
    resolver.watch(this.handleResolverUpdate);
  },
  stopWatching: function stopWatching() {
    resolver.unwatch(this.handleResolverUpdate);
  },
  updateAvatarUrl: function updateAvatarUrl(props) {
    var _this = this;

    var avatarURI = resolver.getAvatarURI(props.email || props.domain, props.fetchAvatars, props.portalId);

    if (this.state.avatarURI === avatarURI) {
      return;
    }
    var isDefault = typeof avatarURI !== 'string';
    this.setState({
      avatarURI: avatarURI,
      error: undefined,
      loaded: isDefault
    });
    if (isDefault) {
      return;
    }
    // Forces the browser to load the image into the cache to avoid UI-jitters
    // as the image loads in.
    /* eslint react/no-is-mounted: 0 */
    (0, _Image.fetchImage)(avatarURI).then(function () {
      if (_this.isMounted() && _this.state.avatarURI === avatarURI) {
        _this.setState({ loaded: true });
      }
    }).catch(function (error) {
      if (_this.isMounted() && _this.state.avatarURI === avatarURI) {
        _this.setState({ error: error });
      }
    }).done();
  },
  getClassName: function getClassName(classNameProps) {
    var className = classNameProps.className,
        iconName = classNameProps.iconName,
        size = classNameProps.size;

    return (0, _reactUtils.classNames)('private-avatar', SIZE_CLASSES[size], className, { 'private-with-icon': Boolean(iconName) });
  },
  getDefaultImage: function getDefaultImage(_ref) {
    var defaultImage = _ref.defaultImage,
        domain = _ref.domain,
        objectType = _ref.objectType;

    if (defaultImage) {
      return defaultImage;
    } else if (objectType === COMPANY || domain) {
      return DEFAULT_COMPANY;
    }
    return DEFAULT_CONTACT;
  },
  getSrc: function getSrc(_ref2, _ref3) {
    var src = _ref2.src;
    var computedDefaultImage = _ref3.computedDefaultImage;

    if (src) {
      return src;
    }
    var _state = this.state,
        avatarURI = _state.avatarURI,
        error = _state.error,
        loaded = _state.loaded;

    if (avatarURI && loaded && !error) {
      return avatarURI;
    }
    return computedDefaultImage;
  },
  renderImage: function renderImage(_ref4, _ref5) {
    var imageShape = _ref4.imageShape,
        size = _ref4.size,
        rest = _objectWithoutProperties(_ref4, ['imageShape', 'size']);

    var computedSrc = _ref5.computedSrc;

    var computedImageShape = imageShape;

    if (imageShape === 'default') {
      _devLogger2.default.warn({
        message: 'UIAvatar: `imageShape` value of `default` has been deprecated, please use `square` instead',
        key: 'UIAvatar: deprecated imageShape default prop'
      });
    }

    if (imageShape === 'square') {
      computedImageShape = 'default';
    }

    return _react2.default.createElement(_UIImage2.default, _extends({}, rest, {
      responsive: size === 'responsive',
      shape: computedImageShape,
      src: computedSrc
    }));
  },
  renderIcon: function renderIcon(_ref6) {
    var iconBackgroundColor = _ref6.iconBackgroundColor,
        iconColor = _ref6.iconColor,
        iconName = _ref6.iconName,
        size = _ref6.size;

    var computedSize = BADGE_ICON_SIZES[size];
    if (!iconName || !computedSize) {
      return null;
    }
    return _react2.default.createElement(_UIIconCircle2.default, {
      backgroundColor: iconBackgroundColor,
      color: iconColor,
      className: 'badge-icon',
      name: iconName,
      size: computedSize,
      legacy: true
    });
  },
  render: function render() {
    // These props are used in updateAvatarUrl to determine state.avatarURI.
    var propsNotUsedInRender = ['email', 'fetchAvatars', 'portalId', 'source'];

    var _omit = (0, _underscore.omit)(this.props, propsNotUsedInRender),
        className = _omit.className,
        defaultImage = _omit.defaultImage,
        domain = _omit.domain,
        iconBackgroundColor = _omit.iconBackgroundColor,
        iconColor = _omit.iconColor,
        iconName = _omit.iconName,
        imageShape = _omit.imageShape,
        onClick = _omit.onClick,
        objectType = _omit.objectType,
        size = _omit.size,
        src = _omit.src,
        rest = _objectWithoutProperties(_omit, ['className', 'defaultImage', 'domain', 'iconBackgroundColor', 'iconColor', 'iconName', 'imageShape', 'onClick', 'objectType', 'size', 'src']);

    var computedDefaultImage = this.getDefaultImage({ defaultImage: defaultImage, domain: domain, objectType: objectType });
    var computedSrc = this.getSrc({ src: src }, { computedDefaultImage: computedDefaultImage });

    return _react2.default.createElement(
      'div',
      {
        className: this.getClassName({ className: className, iconName: iconName, size: size }),
        onClick: onClick
      },
      this.renderImage(_extends({ imageShape: imageShape, size: size }, rest), { computedSrc: computedSrc }),
      this.renderIcon({ iconBackgroundColor: iconBackgroundColor, iconColor: iconColor, iconName: iconName, size: size })
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.348/js/avatar/UIAvatar.js
// module id = 225
// module chunks = 0 1